export default "__VITE_ASSET__BtSjK0Wb__"